// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"cbIIBTW","body":"fcohpcI","body-margin":"mB3ucp6","bodyMargin":"mB3ucp6","small-image":"VXeJJXV","smallImage":"VXeJJXV","footer":"AchEUfF"};